export const ROUTES = {
  HOME: '/',
  PRIVACY: '/privacy',
  TERMS: '/terms',
} as const;

export const HOME_ANCHORS = {
  PRODUCT: '/#product',
  HOW_IT_WORKS: '/#how-it-works',
  ABOUT: '/#about',
  PRICING: '/#pricing',
  LOOKING_FOR_WORK: '/#looking-for-work',
} as const;

export const EMAIL = 'info@shift.work';

export const EXTERNAL_LINKS = {
  START_HIRING: 'https://app.shift.work/signup',
  APP_STORE: 'https://apps.apple.com/app/id6449708417',
  GOOGLE_PLAY:
    'https://play.google.com/store/apps/details?id=com.eoin.dempsey.shift',
  INSTAGRAM: 'https://www.instagram.com/workonshift/',
  LINKEDIN: 'https://www.linkedin.com/company/shiftappie/?viewAsMember=true',
  CONTACT_EMAIL: 'mailto:info@shift.work',
} as const;
